import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-products-dropdown',
  templateUrl: './products-dropdown.component.html',
  styleUrl: './products-dropdown.component.scss'
})
export class ProductsDropdownComponent {

  @Input() label: string = 'Common.Products'
  @Input() dataSource: any[] = []
  @Input() isRequired:boolean = false
  @Input() showNameEn:boolean = false
  @Output() setSelected: EventEmitter<any> = new EventEmitter();
  @Output() setSelectedName: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit(){
    if(this.isRequired){
      this.form.get('productId')?.addValidators(Validators.required)
    }
  }

  form: FormGroup = this.fb.group({
    productId: new FormControl(""),
  });

  reset(){
    this.form.reset()
    this.setSelected.emit('')
  }

  onClick() {
    let selected = this.form.get('productId')?.value
    this.setSelected.emit(selected)
    
  }
  onChoose(item:any=null){
    if(item){
      this.setSelectedName.emit(item.NameEn)
    }
  }
}
